import { UserFacingError } from './errors'

export class SignatureRequestsForbiddenError extends UserFacingError {
  constructor() {
    super("You don't have access to this template's signature requests.")
    this.name = 'SignatureRequestsForbiddenError'
  }
}

export class BillingForbiddenError extends UserFacingError {
  constructor() {
    super("You don't have permission to manage billing.")
    this.name = 'BillingForbiddenError'
  }
}

export class SessionRequiredError extends UserFacingError {
  constructor() {
    super('Please sign in again to continue.')
    this.name = 'SessionRequiredError'
  }
}

export class PermissionsForbiddenError extends UserFacingError {
  constructor() {
    super('Only a club manager or outfitter owner can manage permissions.')
    this.name = 'PermissionsForbiddenError'
  }
}

export class PermissionMembershipNotFoundError extends UserFacingError {
  constructor() {
    super('That member is no longer in this organization. Refresh and try again.')
    this.name = 'PermissionMembershipNotFoundError'
  }
}

export class SlugTakenError extends UserFacingError {
  constructor() {
    super('That link is already taken. Choose a different one.')
    this.name = 'SlugTakenError'
  }
}
